import { render, staticRenderFns } from "./AddSteps1.vue?vue&type=template&id=fdafa8f0&scoped=true&"
import script from "./AddSteps1.vue?vue&type=script&lang=js&"
export * from "./AddSteps1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdafa8f0",
  null
  
)

export default component.exports